
import * as XLSX from 'xlsx';
import { formatInTimeZone } from 'date-fns-tz';
import { supabase } from "@/integrations/supabase/client";

export type TableName = 'tips' | 'prizes' | 'winners' | 'universities' | 'prize_allocations' | 'prize_allocation_resets' | 'user_roles';

export const convertDatesToSydneyTime = (data: any[]) => {
  return data.map(item => {
    const newItem = { ...item };
    if (newItem.created_at) {
      newItem.created_at = formatInTimeZone(
        new Date(newItem.created_at),
        'Australia/Sydney',
        'yyyy-MM-dd HH:mm:ss zzz'
      );
    }
    return newItem;
  });
};

export const fetchAllPages = async (tableName: TableName) => {
  let allData: any[] = [];
  let page = 0;
  const pageSize = 1000;
  
  while (true) {
    const { data, error, count } = await (tableName === 'winners' 
      ? supabase.from('winners').select(`
          *,
          created_at,
          prizes (
            name
          ),
          tips (
            content
          )
        `).range(page * pageSize, (page + 1) * pageSize - 1)
      : supabase.from(tableName)
        .select('*', { count: 'exact' })
        .range(page * pageSize, (page + 1) * pageSize - 1)
    );

    if (error) throw error;
    if (!data || data.length === 0) break;

    allData = [...allData, ...data];
    
    if (data.length < pageSize) break;
    
    page++;
  }

  return convertDatesToSydneyTime(allData);
};
